<template>
 <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">游客画像</div>
      </zj-layout-header>
      <div style="height:50%">
        <div style="margin-left:3%;">
          <el-form>
            <el-form-item label="日期">
                <el-date-picker
                    v-model="date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    style="width:60rem;"
                    unlink-panels
                    :clearable="false"
                    @change="selectDay"
                ></el-date-picker>
            </el-form-item>
          </el-form>
        </div>
        <div style="height:85%;margin-left:3%;">
            <div id="echart-pie-sex" style="width: 50%;height: 100%;float:left;"></div>
            <div id="echart-pie-age" style="width: 50%;height: 100%;float:left;"></div>
        </div>
      </div>
      <div style="height:50%;margin-top:5%;">
        <div  style="height:85%;margin-left:3%;">
            <div id="echart-bar-province" style="width: 50%;height: 100%;float:left;"></div>
            <div id="echart-bar-city" style="width: 50%;height: 100%;float:left;"></div>
        </div>
      </div>
    </zj-layout-container>
  </div>
</template>
<script>

import MyApis from "../../../apis";
import * as echarts from "echarts"

export default {
  name: "TouristsportraitView",
  controller: "UI",
  action: "TouristsportraitView",
  components: {
  },
  data() {
    return {
      loading: false,
      loadingText: '加载中...',
      date: [new Date(), new Date()]
    };
  },
  mounted: function () {
    this.selectDay();
  },
  methods: {
    selectDay() {
      let that = this;
      let searchInfo = {
        BeginTime:
          this.date == null
          ? "0001-01-01T00:00:00"
          : this.date[0].format("yyyy-MM-dd 00:00:00"),
        EndTime:
          this.date == null
          ? "0001-01-01T00:00:00"
          : this.date[1].format("yyyy-MM-dd 23:59:59"),
      };
      new MyApis.TicketApi()
      .GetTourist_FlowStat_TimePeriod(searchInfo) //到时候需要换成大数据那边的接口
      .then((r) => {
        r = r.data.Data;
              
        that.drawSexChart(r);
        that.drawAgeChart(r);
        that.drawProvinceChart(r);
        that.drawCityChart(r);
      })
      .catch((e) => {
        console.log(e);
        that.$message({
          type: "error",
          message: e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！",
        });
      });
    },
    drawSexChart(data) {
        if(data)
        {
            // var legendData = [];
            // var seriesData = [];
            // for  (var i = 0; i < data.length; i++)
            // {
            //     var item=data[i];
            //     seriesData.push({
            //         name: item.name,
            //         value: item.value
            //     });
            //     legendData.push(item.name);
            // }
            var COLORS = ['#47f4de',  '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'];
            var myChart = echarts.init(document.getElementById('echart-pie-sex'));
            var colors = COLORS.slice(parseInt(Math.random() * COLORS.length / 2));
            myChart.setOption({
                color:colors,
                title: {
                    show: true,
                    text: "游客男女比例",
                    left: 'center',
                    textStyle: {
                        color: '#fff'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{b}: {c} ({d}%)"
                },
                legend:{
                    x: 'center',
                    y: 'bottom',
                    data: ["男","女"],
                    textStyle:{ color:'#fff'}
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        dataView: { show: false, readOnly: false },
                        magicType: {
                            show: true,
                            type: ['pie', 'funnel']
                        }
                    }
                },
                calculable: true,
                series:[{ 
                    name: '数量',
                    type: 'pie',
                    radius: ['50%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                        normal: {
                            show: true
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    data:[
                        {name:"男",value:180},
                        {name:"女",value:110},
                    ]
                }]
            })
        }     
    },
    drawAgeChart(data) {
        if(data)
        {
            // var legendData = [];
            // var seriesData = [];
            // for  (var i = 0; i < data.length; i++)
            // {
            //     var item=data[i];
            //     seriesData.push({
            //         name: item.name,
            //         value: item.value
            //     });
            //     legendData.push(item.name);
            // }
            var COLORS = ['#47f4de',  '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'];
            var myChart = echarts.init(document.getElementById('echart-pie-age'));
            var colors = COLORS.slice(parseInt(Math.random() * COLORS.length / 2));
            myChart.setOption({
                color:colors,
                title: {
                    show: true,
                    text: "游客年龄段比例",
                    left: 'center',
                    textStyle: {
                        color: '#fff'
                    }
                },
                tooltip: {
                    trigger: 'item',
                    formatter: "{b}: {c} ({d}%)"
                },
                legend:{
                    x: 'center',
                    y: 'bottom',
                    data: ["0-15","16-22","23-45","46-65","66以上"],
                    textStyle:{ color:'#fff'}
                },
                toolbox: {
                    show: true,
                    feature: {
                        mark: { show: true },
                        dataView: { show: false, readOnly: false },
                        magicType: {
                            show: true,
                            type: ['pie', 'funnel']
                        }
                    }
                },
                calculable: true,
                series:[{ 
                    name: '数量',
                    type: 'pie',
                    radius: ['50%', '70%'],
                    avoidLabelOverlap: false,
                    label: {
                        normal: {
                            show: true
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    lableLine: {
                        normal: {
                            show: false
                        },
                        emphasis: {
                            show: true
                        }
                    },
                    data:[
                        {name:"0-15",value:180},
                        {name:"16-22",value:110},
                        {name:"23-45",value:80},
                        {name:"46-65",value:110},
                        {name:"66以上",value:80},
                    ]
                }]
            })
        }     
    },
    drawProvinceChart(data) {
        if(data)
        {
            // var legendData = [];
            // var seriesData = [];
            // for  (var i = 0; i < data.length; i++)
            // {
            //     var item=data[i];
            //     seriesData.push({
            //         name: item.name,
            //         value: item.value
            //     });
            //     legendData.push(item.name);
            // }
            var COLORS = ['#47f4de',  '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'];
            var myChart = echarts.init(document.getElementById('echart-bar-province'));
            var colors = COLORS.slice(parseInt(Math.random() * COLORS.length / 2));
            myChart.setOption({
                color:colors,
                title: {
                    show: true,
                    text: "客源地省份排行Top10",
                    left: 'center',
                    textStyle: {
                        color: '#fff'
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['吉林省', '辽宁省', '河北省', '山东省', '山西省', '河南省','江苏省','浙江省','湖北省','湖南省'],
                    axisLabel:{
                        color: '#fff'
                    },
                    axisLine:{
                        lineStyle:{
                            color: '#fff',
                            width: 1,
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    axisLine:{
                        lineStyle: {
                            color: '#fff',
                            width: 1,
                        }
                    }
                },
                series:[  //现在为写死的数据 到时候需要换成大数据那边接口的数据
                    { 
                        barWidth:'20%',
                        type: 'bar',
                        data: [920, 832, 701, 634, 550, 430, 310,220, 182, 141]
                    }
                ]
            })
        }     
    },
    drawCityChart(data) {
        if(data)
        {
            // var legendData = [];
            // var seriesData = [];
            // for  (var i = 0; i < data.length; i++)
            // {
            //     var item=data[i];
            //     seriesData.push({
            //         name: item.name,
            //         value: item.value
            //     });
            //     legendData.push(item.name);
            // }
            var COLORS = ['#47f4de',  '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'];
            var myChart = echarts.init(document.getElementById('echart-bar-city'));
            var colors = COLORS.slice(parseInt(Math.random() * COLORS.length / 2));
            myChart.setOption({
                color:colors,
                title: {
                    show: true,
                    text: "客源地省内地市排行Top10",
                    left: 'center',
                    textStyle: {
                        color: '#fff'
                    }
                },
                tooltip: {
                    trigger: 'axis'
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['长春市','吉林市', '四平市', '辽源市', '通化市', '白山市', '松原市','白城市'],
                    axisLabel:{
                        color: '#fff'
                    },
                    axisLine:{
                        lineStyle:{
                            color: '#fff',
                            width: 1,
                        }
                    }
                },
                yAxis: {
                    type: 'value',
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        show: true,
                        textStyle: {
                            color: '#fff'
                        }
                    },
                    axisLine:{
                        lineStyle: {
                            color: '#fff',
                            width: 1,
                        }
                    }
                },
                series:[  //现在为写死的数据 到时候需要换成大数据那边接口的数据
                    { 
                        barWidth:'20%',
                        type: 'bar',
                        data: [701, 634, 550, 430, 310,220, 182, 141]
                    }
                ]
            })
        }     
    }
  }
}

</script>